export default {
  INFANT: 'infant',
  JUVENILE: 'child',
  SENIOR: 'senior',
  AGE_DISCOUNT_GROUPS: ['infant', 'child', 'senior'],
};



// WEBPACK FOOTER //
// ./src/variables/itineraryPrices/ageDiscountTypes.js